import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const MODULE_ROUTE_MAP: Record<string, string> = {
  sales: 'Sales',
  scm: 'SupplyChain',
  finance: 'Finance',
  mfg: 'Manufacturing',
  quality: 'Quality',
  projects: 'Projects',
  hr: 'HR',
};

/**
 * Deep-link into the unified execution board with a module filter (TASKKANBAN module-wise boards).
 */
const ModuleTasksRedirect: React.FC = () => {
  const { moduleKey = '' } = useParams<{ moduleKey: string }>();
  const moduleName = MODULE_ROUTE_MAP[moduleKey.toLowerCase()] || 'Sales';
  return <Navigate to={`/unified?module=${encodeURIComponent(moduleName)}`} replace />;
};

export default ModuleTasksRedirect;
